import React, { useEffect, useState, useRef } from "react";
import api from "../../services/api";
import { toast } from "react-toastify";
import { InputField } from "../../components";
import TagsInput from "../../components/CustomTagsInput";
import Loading from "../../components/Loader/Loading";
import { MultiSelect } from "primereact/multiselect";
export default function AddUpdateUserForm({
  handleModal,
  fetchUsersData,
  isLoading,
  setIsLoading,
  modalType,
  user,
  roles,
  merchantList,
}) {
  // New User
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [role_id, setRoleId] = useState([]);
  const [is_active, setIsActive] = useState(1);
  const [isAssignUserList, setAssignUserList] = useState([]);
  const [isChildUserList, setChildUserList] = useState([]);
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [proxies, setProxies] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [merchant_id, setMerchantId] = useState("");
  const [merchants, setMerchants] = useState([]);
  const [proxy_id, setProxyId] = useState("");
  useEffect(() => {
    if (modalType === "editUser") {
      setName(user.name);
      setEmail(user.email);
      setUsername(user.username);
      setPassword(user.without_encrypted_password);
      setRoleId(user?.role_id);
      setMerchantId(user?.merchant_id);
      setMerchants(JSON.parse(user?.merchants));
      setIsActive(user?.is_active);
    } else if (modalType === "newUser") {
      setName("");
      setEmail("");
      setUsername("");
      setPassword("");
      setRoleId("");
      setMerchantId("");
      setMerchants("");
      setIsActive(1);
      setProxyId("");
    }
    getAssignedUsers();
    getChildUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalType, user]);
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const newErrors = {};

    if (!name.trim()) newErrors.name = "Please enter the full name.";
    if (!email.trim()) {
      newErrors.email = "Please enter the email.";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Please enter a valid email address.";
    }
    if (!username.trim()) newErrors.username = "Please enter the username.";
    if (modalType === "newUser" && !password.trim()) {
      newErrors.password = "Please enter the password.";
    }
    if (!role_id) newErrors.role_id = "Please enter the role.";
    if (!merchant_id) newErrors.merchant_id = "Please select merchant.";
    if (!merchants || merchants.length === 0) {
      newErrors.merchants = "Please select at least one merchant.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsLoading(false);
      return;
    }

    const userData = {
      name,
      email,
      username,
      password,
      role_id,
      merchant_id: parseInt(merchant_id),
      merchants,
      is_active,
      ...(modalType === "newUser" ? { proxy_id } : {}),
    };
    if (modalType === "newUser") {
      api
        .post(`${process.env.REACT_APP_PUBLIC_API}/api/users/addUser`, userData)
        .then(() => {
          handleModal();
          fetchUsersData();
          toast.success("New User Created!", { autoClose: 3000 });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (modalType === "editUser" && user.id) {
      api
        .put(`${process.env.REACT_APP_PUBLIC_API}/api/users/updateUser`, {
          id: user.id,
          ...userData,
        })
        .then(() => {
          handleModal();
          fetchUsersData();
          toast.success("User updated successfully!", { autoClose: 3000 });
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const getAssignedUsers = async () => {
    setIsUserLoading(true);
    try {
      const response = await api.get(
        `${process.env.REACT_APP_PUBLIC_API}/api/users/list_parent_users?user_id=${user?.id}`
      );
      setTagData(response?.data.map((item) => item.name.trim()));
      await setAssignUserList(response.data);
      setIsUserLoading();
    } catch (error) {
      console.error(`Error fetching users data: ${error}`);
    }
  };
  const getChildUsers = async () => {
    setIsUserLoading(true);
    try {
      const response = await api.get(
        `${process.env.REACT_APP_PUBLIC_API}/api/users/list_sub_users?user_id=${user?.id}`
      );
      setChildUserList(response?.data.map((item) => item.name.trim()));
      setIsUserLoading();
    } catch (error) {
      console.error(`Error fetching users data: ${error}`);
    }
  };
  const multiloginProxies = async () => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_PUBLIC_API}/api/multilogin/proxies`
      );
      setProxies(response?.data);
    } catch (error) {
      console.error(`Error fetching proxies data: ${error}`);
    }
  };
  useEffect(() => {
    multiloginProxies();
  }, []);

  const clearError = (field, condition = true) => {
    if (condition) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const multiSelectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownEl = multiSelectRef.current?.getElement();
      const panelEl = document.querySelector(".p-multiselect-panel");

      if (
        dropdownEl &&
        panelEl &&
        !dropdownEl.contains(event.target) &&
        !panelEl.contains(event.target)
      ) {
        multiSelectRef.current?.hide();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      {isUserLoading && modalType === "editUser" && <Loading />}
      <div className="grid md:grid-cols-2 gap-4 w-full">
        <InputField
          label="name"
          name="name"
          placeholder="Enter full name"
          value={name}
          onChange={(e) => {
            setName(e.target.value);
            clearError("name", e.target.value.trim());
          }}
          error={errors.name}
          required
        />
        <InputField
          label="email"
          name="email"
          placeholder="Enter user email"
          type="email"
          value={email}
          onChange={(e) => {
            const value = e.target.value;
            setEmail(value);

            // Clear errors conditionally
            if (!value.trim()) {
              setErrors((prev) => ({
                ...prev,
                email: "Please enter the email.",
              }));
            } else if (!/\S+@\S+\.\S+/.test(value)) {
              setErrors((prev) => ({
                ...prev,
                email: "Please enter a valid email address.",
              }));
            } else {
              clearError("email");
            }
          }}
          error={errors.email}
          required
        />

        <InputField
          label="username"
          name="username"
          placeholder="Enter username"
          value={username}
          onChange={(e) => {
            setUsername(e.target.value);
            clearError("username", e.target.value.trim());
          }}
          disabled={modalType === "editUser"}
          error={errors.username}
          required
          autoComplete="new-username"
        />
        {modalType === "newUser" && (
          <InputField
            label="password"
            name="password"
            placeholder="Enter password"
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              clearError("password", e.target.value.trim());
            }}
            error={errors.password}
            required
            autoComplete="new-password"
          />
        )}

        <div className="mt-2">
          <label htmlFor="roleId" className="inputLabel">
            Select Role:
          </label>
          <select
            value={role_id}
            onChange={(e) => {
              setRoleId(e.target.value);
              clearError("role_id", e.target.value);
            }}
            name="role_id"
            className={`inputField mt-1 ${
              errors.role_id ? "border-red-500" : ""
            }`}
          >
            <option value="">Select Role</option>
            {roles?.map(({ id, name }) => (
              <option key={id} value={id}>
                {name}
              </option>
            ))}
          </select>
          {errors.role_id && (
            <div className="text-red-500">{errors.role_id}</div>
          )}
        </div>

        <div className="mt-2">
          <label className="inputLabel">Primary Merchant:</label>
          <select
            value={merchant_id}
            onChange={(e) => {
              setMerchantId(e.target.value);
              clearError("merchant_id", e.target.value);
            }}
            name="merchant_id"
            className={`inputField mt-1 ${
              errors.merchant_id ? "border-red-500" : ""
            }`}
          >
            <option value="">Select</option>
            {merchantList?.map(({ id, company_name }) => (
              <option key={id} value={id}>
                {company_name}
              </option>
            ))}
          </select>
          {errors.merchant_id && (
            <div className="text-red-500">{errors.merchant_id}</div>
          )}
        </div>

        <div className="mt-2">
          <label className="inputLabel">Select Merchants:</label>
          <MultiSelect
            ref={multiSelectRef}
            placeholder="Select Merchants"
            options={merchantList}
            optionLabel="company_name"
            optionValue="id"
            filter
            maxSelectedLabels={2}
            value={merchants}
            onChange={(e) => {
              setMerchants(e.value);
              if (e.value.length > 0) clearError("merchants");
            }}
            className="h-[40px] w-full !rounded-[4px] focus:!shadow-none border border-gray-300 hover:border-gray-300"
            panelClassName="bg-gray-300 border border-gray-300"
          />
          {errors.merchants && (
            <div className="text-red-500">{errors.merchants}</div>
          )}
        </div>

        <div className="mt-2">
          <label className="inputLabel">Active:</label>
          <select
            value={is_active}
            onChange={(e) => setIsActive(e.target.value)}
            name="is_active"
            className="inputField mt-1"
          >
            <option value={1}>Active</option>
            <option value={0}>Inactive</option>
          </select>
        </div>

        {modalType === "editUser" && (
          <>
            <div className="mt-2">
              <label className="inputLabel">Parent Users:</label>
              {isAssignUserList?.length > 0 && (
                <div className="col-span-1 !my-3">
                  <TagsInput tags={tagData} setTags={setTagData} disable />
                </div>
              )}
            </div>
            <div>
              <label className="inputLabel">Child Users:</label>
              {isChildUserList?.length > 0 && (
                <div className="col-span-1 !my-3">
                  <TagsInput
                    tags={isChildUserList}
                    setTags={setChildUserList}
                    disable
                  />
                </div>
              )}
            </div>
          </>
        )}

        {modalType === "newUser" && (
          <div className="mt-2">
            <label className="inputLabel">Select Proxy:</label>
            <select
              value={proxy_id}
              onChange={(e) => setProxyId(e.target.value)}
              name="proxy_id"
              className="inputField mt-1"
            >
              <option value="">Select Proxy</option>
              {proxies?.map(({ id, proxy_ip }) => (
                <option key={id} value={id}>
                  {proxy_ip}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="flex items-cente justify-end mt-5 space-x-2 text-white">
        <button
          onClick={handleModal}
          type="button"
          className="btnPrimary bg-red-500"
        >
          Cancel
        </button>

        {isLoading ? (
          <div className="bg-blue/10 flex items-center justify-center rounded-md py-2 w-48">
            <img src="/img/loading.gif" className="w-7" alt="" />
          </div>
        ) : (
          <button
            type="button"
            onClick={handleSubmit}
            className="btnPrimary bg-green-600"
          >
            Save and Update
          </button>
        )}
      </div>
    </div>
  );
}
